import { API } from 'aws-amplify';
import { TUTORING_V2_URL_APPEND } from 'constants';

export const getTutoringSubjectsV2 = async () => {
  const tutoringSubjectV2List = await API.get(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/subjects`,
    {},
  );
  const { subjects } = tutoringSubjectV2List;

  return subjects || [];
};

export const getTutoringSubjectsV2Tutors = async (subjectId) => {
  const tutoringSubjectV2TutorList = await API.get(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/subjects/${subjectId}/tutors`,
    {},
  );
  const { assignments } = tutoringSubjectV2TutorList;

  return assignments || [];
};

export const getTutoringSubjectsV2TimeSlots = async (subjectId) => {
  const tutoringSubjectV2Timeslots = await API.get(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/subjects/${subjectId}/timeslots`,
    {},
  );

  return tutoringSubjectV2Timeslots || [];
};

export const postTutoringSubjectV2 = async (payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post('delta-api', `${TUTORING_V2_URL_APPEND}/subjects`, myPayload);
};

export const putTutoringSubjectV2 = async (payload, id) => {
  const myPayload = {
    body: payload,
  };

  await API.put(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/subjects/${id}`,
    myPayload,
  );
};

export const postTutoringSubjectsV2Tutor = async (subjectId, payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/subjects/${subjectId}/tutors`,
    myPayload,
  );
};

export const deleteTutoringSubjectV2 = async (subjectId) => {
  await API.del('delta-api', `${TUTORING_V2_URL_APPEND}/subjects/${subjectId}`);
};

export const removeAssignedTutor = async (assignmentId) => {
  await API.del(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/tutors/assignments/${assignmentId}`,
  );
};

export const putTutoringSubjectV2TutorAssignment = async (
  assignmentId,
  payload,
) => {
  const myPayload = {
    body: payload,
  };

  await API.put(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/tutors/assignments/${assignmentId}`,
    myPayload,
  );
};
